import { FaHandsHoldingCircle, FaToolbox } from "react-icons/fa6";
import { HiClipboardList } from "react-icons/hi";
import { RiCheckLine, RiTeamFill } from "react-icons/ri";

export const servicesData = [
  {
    icon: "/assets/images/icons/results.svg",
    title: "Workshops",
    description:
      "We offer hands-on training to help you understand and apply medical statistics effectively.",
    image: "/assets/images/about-banner.webp",
    url: "/services/results",
    benefits: [
      {
        icon: RiCheckLine,
        title: "Clear Outputs",
        description:
          "We provide clear, concise results that are easy to understand and ready for publication.",
      },
      {
        icon: RiCheckLine,
        title: "Tailored Analysis",
        description:
          "Our results are customized to meet the specific needs of your research project.",
      },
      {
        icon: RiCheckLine,
        title: "Expert Review",
        description:
          "Each result is reviewed by our team of experts to ensure accuracy and reliability.",
      },
      {
        icon: RiCheckLine,
        title: "Fast Turnaround",
        description:
          "We deliver results quickly without compromising on quality, so you can keep your research moving forward.",
      },
    ],
  },
  {
    icon: "/assets/images/icons/results.svg",
    title: "Results",
    description:
      "We organize and present your data clearly, ready for publication or reporting.",
    image: "/assets/images/about-banner.webp",
    url: "/services/results",
    benefits: [
      {
        icon: RiCheckLine,
        title: "Clear Outputs",
        description:
          "We provide clear, concise results that are easy to understand and ready for publication.",
      },
      {
        icon: RiCheckLine,
        title: "Tailored Analysis",
        description:
          "Our results are customized to meet the specific needs of your research project.",
      },
      {
        icon: RiCheckLine,
        title: "Expert Review",
        description:
          "Each result is reviewed by our team of experts to ensure accuracy and reliability.",
      },
      {
        icon: RiCheckLine,
        title: "Fast Turnaround",
        description:
          "We deliver results quickly without compromising on quality, so you can keep your research moving forward.",
      },
    ],
  },
  {
    icon: "/assets/images/icons/results.svg",
    title: "Meta Analysis",
    description:
      "We combine results from multiple studies to provide strong, evidence-based conclusions.",
    image: "/assets/images/about-banner.webp",
    url: "/services/results",
    benefits: [
      {
        icon: RiCheckLine,
        title: "Clear Outputs",
        description:
          "We provide clear, concise results that are easy to understand and ready for publication.",
      },
      {
        icon: RiCheckLine,
        title: "Tailored Analysis",
        description:
          "Our results are customized to meet the specific needs of your research project.",
      },
      {
        icon: RiCheckLine,
        title: "Expert Review",
        description:
          "Each result is reviewed by our team of experts to ensure accuracy and reliability.",
      },
      {
        icon: RiCheckLine,
        title: "Fast Turnaround",
        description:
          "We deliver results quickly without compromising on quality, so you can keep your research moving forward.",
      },
    ],
  },
  {
    icon: "/assets/images/icons/sample-size.svg",
    title: "Sample Size",
    description:
      "We calculate the optimal sample size to ensure your study is statistically valid and reliable.",
    image: "/assets/images/sample-size.webp",
    url: "/services/sample-size",
    benefits: [
      {
        icon: FaHandsHoldingCircle,
        title: "Hands On Practise",
        description:
          "Get real experience by applying what you learn during the session. No theory overload — just practical work you can use right away.",
      },
      {
        icon: FaToolbox,
        title: "Real Tools",
        description:
          "Get real experience by applying what you learn during the session. No theory overload — just practical work you can use right away.",
      },
      {
        icon: HiClipboardList,
        title: "Simple Steps",
        description:
          "Get real experience by applying what you learn during the session. No theory overload — just practical work you can use right away.",
      },
      {
        icon: RiTeamFill,
        title: "Expert Support",
        description:
          "Get real experience by applying what you learn during the session. No theory overload — just practical work you can use right away.",
      },
    ],
  },
  {
    icon: "/assets/images/icons/data-entry.svg",
    title: "Data Entry",
    description:
      "We enter your data accurately and securely, saving you time and avoiding costly mistakes.",
    image: "/images/data-entry.jpg",
    url: "/services/data-entry",
    benefits: [
      {
        icon: RiCheckLine,
        title: "Clear Outputs",
        description:
          "We provide clear, concise results that are easy to understand and ready for publication.",
      },
      {
        icon: RiCheckLine,
        title: "Tailored Analysis",
        description:
          "Our results are customized to meet the specific needs of your research project.",
      },
      {
        icon: RiCheckLine,
        title: "Expert Review",
        description:
          "Each result is reviewed by our team of experts to ensure accuracy and reliability.",
      },
      {
        icon: RiCheckLine,
        title: "Fast Turnaround",
        description:
          "We deliver results quickly without compromising on quality, so you can keep your research moving forward.",
      },
    ],
  },

  {
    icon: "/assets/images/icons/result-comments.svg",
    title: "Result Comments",
    description:
      "We explain what your results mean, so you can write your discussion with clarity and confidence.",
    image: "/assets/images/results-comments.webp",
    url: "/services/results",
    benefits: [
      {
        icon: RiCheckLine,
        title: "Clear Outputs",
        description:
          "We provide clear, concise results that are easy to understand and ready for publication.",
      },
      {
        icon: RiCheckLine,
        title: "Tailored Analysis",
        description:
          "Our results are customized to meet the specific needs of your research project.",
      },
      {
        icon: RiCheckLine,
        title: "Expert Review",
        description:
          "Each result is reviewed by our team of experts to ensure accuracy and reliability.",
      },
      {
        icon: RiCheckLine,
        title: "Fast Turnaround",
        description:
          "We deliver results quickly without compromising on quality, so you can keep your research moving forward.",
      },
    ],
  },
];
